// getImage resolves undefined when the key is empty or the fetch failed.
// Return a truthy marker instead of "data:...base64,undefined" (a broken <img>):
// BoxImage renders imageNotFound for it, and edit forms still treat it as
// "has an image", so saving keeps the stored key.
export const IMAGE_NOT_FOUND = "image not found";

export const isImageNotFound = (src) =>
  typeof src === "string" &&
  (src.includes("not found") || /base64,(undefined|null)?$/.test(src));

export const UseConvertImageToBase64 = (imageUrl) => {
  if (!imageUrl || typeof imageUrl !== "string") {
    return IMAGE_NOT_FOUND;
  }
  const newImage = `data:image/png;base64,${imageUrl}`;
  return newImage;
};
// UseConvertImageToBase64(imageUrlNew)
